import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { VerificaService } from './verifica.service';

declare var Materialize:any;

@Component({
  selector: 'app-validacao',
  templateUrl: './validacao.component.html',
  styleUrls: ['./validacao.component.css'],
  providers: [VerificaService]
})
export class ValidacaoComponent implements OnInit {
  public codigo:string;
  public titulo:string = "Verificar autenticidade do documento";
  public docValido:boolean = false;
  public docInvalido:boolean = false;
  public obj:any = {nome:"", acao:"", criadoem:""};
  public busy: Promise<any>;

  constructor(public verificarService: VerificaService) { }

  verificar():void{
      this.busy = this.verificarService.verificar(this.codigo)
        .then((response) => this.valido(response))
        .catch((error) => this.invalido(error));
  }

  valido(response:any): void{
    this.obj = response;
    this.docValido = true;
    this.docInvalido = false;
    console.log(this.obj);
  }

  invalido(error:any): void{
    this.docInvalido = true;
    this.docValido = false;
  }

  ngOnInit() {
  }



}



// WEBPACK FOOTER //
// ./src/app/validacao/validacao.component.ts